import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GetDataService } from '../../services/getdata.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: 'app-lab-cart',
  templateUrl: './lab-cart.component.html',
  styleUrls: ['./lab-cart.component.css']
})
export class LabCartComponent implements OnInit {

  cartDetails:{color:string,id:string,location:string,dateOfCreation:string,capacity:string,createdBy:string, quantity:number,
    details:{sampleType:string,sampleId:string,status:string}[]}= {
      color:'',
      id:'',
      location:'',
      dateOfCreation:'',
      capacity:'',
      createdBy:'',
      quantity:0,
      details:[]
    };
  
  id = "";
  constructor(private activatedRoute:ActivatedRoute,private dataService:GetDataService,private ngxservice:NgxUiLoaderService) { 
    this.activatedRoute.queryParams.subscribe(response=>{
      if(response && response.id){
        this.id = response.id;
        this.getCartDetailsById(response.id);
      }
    })
  }

  ngOnInit(): void {
  }

  getCartDetailsById=(id:string)=>{
    this.ngxservice.start();
    this.dataService.getCartDetailsById(id).subscribe(response=>{
      if(response && response.status_code && response.data && response.data.length>0){
        const cart = response.data[0];
        const sampleDetails  = response.data[0].sample_details?response.data[0].sample_details:[];
        let details:any=[];
        sampleDetails.forEach((item:any)=>{
          details.push({sampleType:item.sample_type,sampleId:item.sample_id,status:item.status})
        })
        this.cartDetails = {
          color:cart.cart_colour, location:cart.cart_location,id:this.id,dateOfCreation:cart.date_of_cart_creation,createdBy:cart.admin_name,
          quantity:cart.total_quantity,details:details,capacity:cart.capacity
        };
      }
      this.ngxservice.stop();
    },error=>{
      console.error('error while getting cart details by id',error);
      this.ngxservice.stop();
    })
  }

}
